import React, { useCallback, useEffect, useState } from "react";
import { Box, Alert, Typography } from "@mui/material";
import PageLoading from "@/app/components/shared/pageLoading";
import dataService from "@/app/services/dataService";
import { OrderNotificationResponse } from "@/app/models/orderNotification/types";
import { useSelector } from "react-redux";
import { RootState } from "@/app/store/store";
import { OrderNotificationPreferences } from "../../checkout/orderPlaced/orderNotificationPreferences";

const OrderNotificationsPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState<OrderNotificationResponse>();
  const [error, setError] = useState<string | null>(null);

  const userId = useSelector(
    (state: RootState) => state.userState.user.id ?? 0
  );
  const loadOrderNotifications = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await dataService.getOrderNotification(userId);
      if (res?.success && res.data) {
        if (res.data.isAccessDenied) window.location.href = "/lbpcustomer";
        else setModel(res.data as OrderNotificationResponse);
      }
    } catch (e: any) {
      setError(
        e?.response?.data?.message ||
          e?.message ||
          "Failed to load preferences."
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      await loadOrderNotifications();
      if (cancelled) return;
    })();
    return () => {
      cancelled = true;
    };
  }, [loadOrderNotifications]);

  if (loading) return <PageLoading />;

  return (
    <Box sx={{ background: "#f8f8f8" }}>
      <Box
        sx={{
          backgroundColor: "#62b5e5",
          marginBottom: "50px",
          minHeight: "100px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            fontSize: "36px",
          }}
        >
          Order Notifications
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {model && (
          <OrderNotificationPreferences model={model} isAccount={true} />
        )}
      </Box>
    </Box>
  );
};

export default OrderNotificationsPage;
